import * as searchHelpers from './directory-demo-search-helpers';
import axios from "axios";
import { createStore } from 'vuex'

const store = createStore({
    state: {
        searchInProgress: false,
        ideasInProgress: false,
        shipsInternationally: undefined,
        shipsToMyLocation: undefined,
        minimumOrderValue: undefined,
        selectedTypes: [],
        searchResultData: {
            count: 0,
            results: [],
            hasNextPage: false,
            foundResultsText: ""
        },
        ideas: [],
        term: undefined,
        page: 1,
        limit: 10,
        searchRequestSource: undefined,
        termSuggestionRequestSource: undefined,
        currentSuggestions: {}
    },
    actions: {
        /**
         * @param {{}} context
         * @param {{}} [payload=undefined]
         */
        search(context, payload) {
            let term = payload !== undefined && payload.term !== undefined ? payload.term : undefined,
                countries = [];

            if (term === undefined) {
                term = context.state.term;
            } else {
                context.commit('term', term);
            }

            if (context.state.searchRequestSource !== undefined) {
                context.state.searchRequestSource.cancel('New search term entered');
            }

            context.commit('searchRequestSource', axios.CancelToken.source());
            context.commit('startSearch')

            if (context.state.shipsToMyLocation && payload.currentLocationCountryCode) {
                countries.push(payload.currentLocationCountryCode);
            }

            axios.get(
                '/directory/demo-search',
                {
                    params: {
                        query: term,
                        limit: context.state.limit,
                        ships_internationally: context.state.shipsInternationally,
                        countries: countries,
                        minimum_order_value: context.state.minimumOrderValue,
                        types: context.state.selectedTypes
                    },
                    headers: {'X-Requested-With': 'XMLHttpRequest'},
                    cancelToken: context.state.searchRequestSource.token
                }).then(response => {
                    if (response.data.count === 0) {
                        context.commit('setIdeasInProgress', true);

                        axios.get(
                            '/directory-demo/ideas',
                            {
                                headers: {
                                    'X-Requested-With': 'XMLHttpRequest'
                                }
                            }).then(response => {
                                // [0] = Display text
                                // [1] = Search query
                                // [2] = Supplier search count
                                // [3] = Product search count
                                // [4] = Source
                                // [5] = Image URL
                                // [6] = Image URL raw
                                context.commit('ideas', response.data);
                                context.commit('setIdeasInProgress', false);
                            }, xhr => {
                                this.ideasInProgress = false;
                            });
                    }

                    context.commit('searchRequestSource', undefined);
                    context.commit('searchResultData', response.data);
                    context.commit('stopSearch');
                }, xhr => {
                    context.commit('searchRequestSource', undefined);
                    context.commit('stopSearch');
                });
        },

        /**
         * Get a random suggestions from linked Google Sheet to trigger a new search
         *
         * @param {{}} context
         */
        randomSearch(context) {
            axios.get(
            '/app/directory/suggest-demo.php',
            {
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
            }).then(response => {
                // new search with the first random suggestion
                context.dispatch('search', { term: response.data[0] });
            });
        },

        /**
         * @param {{}} context
         * @param {string} [term=state.term]
         */
        suggestionsForTerm(context, term) {
            // we already have curated suggestions don't try and get others
            if (context.state.termSuggestionRequestSource !== undefined) {
                context.state.termSuggestionRequestSource.cancel('New search term entered');
            }

            context.state.termSuggestionRequestSource = axios.CancelToken.source();

            axios.get(
            '/app/directory/suggest.php',
            {
                params: {
                    query: term,
                    include: ['products']
                },
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                cancelToken: context.state.termSuggestionRequestSource.token
            }).then(response => {
                context.state.currentSuggestions = response.data.products;
                context.state.termSuggestionRequestSource = undefined;
            }, xhr => {
                context.state.termSuggestionRequestSource = undefined;
            });
        },

        /**
         * @param {{}} context
         */
        sheetSuggestions(context) {
            axios.get(
            '/app/directory/suggest-demo.php',
            {
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
            }).then(response => {
                context.state.currentSuggestions = response.data;
            });
        }
    },
    getters: {
        /**
         * @param {{}} state
         * @returns {number}
         */
        remainingResultsCount(state) {
            if (state.searchResultData.count === 0) {
                return 0;
            }

            return state.searchResultData.count - (state.page * state.limit);
        }
    },
    mutations: {
        shipsInternationally(state, value) {
            state.shipsInternationally = value;
        },

        shipsToMyLocation(state, value) {
            state.shipsToMyLocation = value;
        },

        minimumOrderValue(state, value) {
            state.minimumOrderValue = value;
        },

        /**
         * @param {{}} state
         * @param sourceValue
         */
        searchRequestSource(state, sourceValue) {
            state.searchRequestSource = sourceValue
        },

        /**
         * @param {{}} state
         */
        startSearch(state) {
            state.searchInProgress = true;
        },

        /**
         * @param {{}} state
         */
        stopSearch(state) {
            state.searchInProgress = false;
        },

        setIdeasInProgress(state, value) {
            state.ideasInProgress = value;
        },

        /**
         * @param {{}} state
         * @param {{}} data
         */
        searchResultData(state, data) {
            state.searchResultData = data;
        },

        ideas(state, data) {
            state.ideas = data;
        },

        /**
         * @param {{}} state
         * @param {{}} types
         */
        selectedTypes(state, types) {
            state.selectedTypes = types;
        },

        /**
         * @param {{}} state
         * @param {string} term
         */
        term(state, term) {
            state.term = term;
        },

        /**
         * @param {{}} state
         * @param {{}} currentSuggestions
         */
        currentSuggestions(state, currentSuggestions) {
            state.currentSuggestions = currentSuggestions;
        },

        /**
         * @param {{}} state
         */
        resetFilters(state) {
            state.shipsInternationally = undefined;
            state.shipsToMyLocation = undefined;
            state.minimumOrderValue = undefined;
            state.selectedTypes = [];
        }
    }
});

export default store;